import { DeclaracionModelo390DtoProps } from "api/DTOs/DeclaracionModelo390Dto"
import { Pag1DeclaracionModelo390DtoProps } from "api/DTOs/Pag1DeclaracionModelo390Dto"
import { Pag2BisDeclaracionModelo390DtoProps } from "api/DTOs/Pag2BisDeclaracionModelo390Dto"
import { Pag2DeclaracionModelo390DtoProps } from "api/DTOs/Pag2DeclaracionModelo390Dto"
import { Pag3DeclaracionModelo390DtoProps } from "api/DTOs/Pag3DeclaracionModelo390Dto"
import { Pag4DeclaracionModelo390DtoProps } from "api/DTOs/Pag4DeclaracionModelo390Dto"
import { Pag6DeclaracionModelo390DtoProps } from "api/DTOs/Pag6DeclaracionModelo390Dto"
import { Pag7DeclaracionModelo390DtoProps } from "api/DTOs/Pag7DeclaracionModelo390Dto"
import { Pag8DeclaracionModelo390DtoProps } from "api/DTOs/Pag8DeclaracionModelo390Dto"
import { frontendDateFormatWhitoutSeparator } from "utils/formatDate"

export interface Modelo390FormModel
  extends Pag1DeclaracionModelo390DtoProps,
    Pag2DeclaracionModelo390DtoProps,
    Pag2BisDeclaracionModelo390DtoProps,
    Pag3DeclaracionModelo390DtoProps,
    Pag4DeclaracionModelo390DtoProps,
    Pag6DeclaracionModelo390DtoProps,
    Pag7DeclaracionModelo390DtoProps,
    Pag8DeclaracionModelo390DtoProps {
  ejercicioDevengo: number
}

export const postModeloDeclaracion390Adapter = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formData: any
): DeclaracionModelo390DtoProps => ({
  ejercicioDevengo: formData?.ejercicioDevengo,
  pag1: {
    actividadOtra1Codigo: formData?.actividadOtra1Codigo,
    actividadOtra1Descripcion: formData?.actividadOtra1Descripcion,
    actividadOtra1Epigrafe: formData?.actividadOtra1Epigrafe,
    actividadOtra2Codigo: formData?.actividadOtra2Codigo,
    actividadOtra2Descripcion: formData?.actividadOtra2Descripcion,
    actividadOtra2Epigrafe: formData?.actividadOtra2Epigrafe,
    actividadOtra3Codigo: formData?.actividadOtra3Codigo,
    actividadOtra3Descripcion: formData?.actividadOtra3Descripcion,
    actividadOtra3Epigrafe: formData?.actividadOtra3Epigrafe,
    actividadOtra4Codigo: formData?.actividadOtra4Codigo,
    actividadOtra4Descripcion: formData?.actividadOtra4Descripcion,
    actividadOtra4Epigrafe: formData?.actividadOtra4Epigrafe,
    actividadOtra5Codigo: formData?.actividadOtra5Codigo,
    actividadOtra5Descripcion: formData?.actividadOtra5Descripcion,
    actividadOtra5Epigrafe: formData?.actividadOtra5Epigrafe,
    actividadPrincipalCodigo: formData?.actividadPrincipalCodigo,
    actividadPrincipalDescripcion: formData?.actividadPrincipalDescripcion,
    actividadPrincipalEpigrafe: formData?.actividadPrincipalEpigrafe,
    apellidosRazonSocial: formData?.apellidosRazonSocial,
    concursoAcreedores: formData?.concursoAcreedores,
    declaracionAnualOperacionesTerceros:
      formData?.declaracionAnualOperacionesTerceros,
    declaracionConjuntaNif: formData?.declaracionConjuntaNif,
    declaracionConjuntaRazonSocial: formData?.declaracionConjuntaRazonSocial,
    declaracionSustitutiva: formData?.declaracionSustitutiva,
    destinatarioRegimenCriterioCaja: formData?.destinatarioRegimenCriterioCaja,
    esDependiente: formData?.esDependiente,
    esDominante: formData?.esDominante,
    identificadorClienteEedd: formData?.identificadorClienteEedd,
    nif: formData?.nif,
    nifEntidadDominante: formData?.nifEntidadDominante,
    nombre: formData?.nombre,
    numeroGrupo: formData?.numeroGrupo,
    numeroJustificanteAnterior: formData?.numeroJustificanteAnterior,
    regimenEspecialCriterioCaja: formData?.regimenEspecialCriterioCaja,
    regimenEspecialGrupoEntidades: formData?.regimenEspecialGrupoEntidades,
    registroDevolucionMensual: formData?.registroDevolucionMensual,
    repFisicaApellidosNombre: formData?.repFisicaApellidosNombre,
    repFisicaCodigoPostal: formData?.repFisicaCodigoPostal,
    repFisicaEscalera: formData?.repFisicaEscalera,
    repFisicaMunicipio: formData?.repFisicaMunicipio,
    repFisicaNif: formData?.repFisicaNif,
    repFisicaNumero: formData?.repFisicaNumero,
    repFisicaPiso: formData?.repFisicaPiso,
    repFisicaProvincia: formData?.repFisicaProvincia,
    repFisicaPuerta: formData?.repFisicaPuerta,
    repFisicaTelefono: formData?.repFisicaTelefono,
    repFisicaViaPublicaNombre: formData?.repFisicaViaPublicaNombre,
    repFisicaViaPublicaTipo: formData?.repFisicaViaPublicaTipo,
    repJuridica1FechaPoder:
      formData?.repJuridica1FechaPoder &&
      frontendDateFormatWhitoutSeparator(formData?.repJuridica1FechaPoder),
    repJuridica1Nif: formData?.repJuridica1Nif,
    repJuridica1NombreApellidos: formData?.repJuridica1NombreApellidos,
    repJuridica1Notaria: formData?.repJuridica1Notaria,
    repJuridica2FechaPoder:
      formData?.repJuridica2FechaPoder &&
      frontendDateFormatWhitoutSeparator(formData?.repJuridica2FechaPoder),
    repJuridica2Nif: formData?.repJuridica2Nif,
    repJuridica2NombreApellidos: formData?.repJuridica2NombreApellidos,
    repJuridica2Notaria: formData?.repJuridica2Notaria,
    repJuridica3FechaPoder:
      formData?.repJuridica3FechaPoder &&
      frontendDateFormatWhitoutSeparator(formData?.repJuridica3FechaPoder),
    repJuridica3Nif: formData?.repJuridica3Nif,
    repJuridica3NombreApellidos: formData?.repJuridica3NombreApellidos,
    repJuridica3Notaria: formData?.repJuridica3Notaria,
    sustitutivaPorRectificacion: formData?.sustitutivaPorRectificacion,
    tipoRegimenEspecialAplicable: formData?.tipoRegimenEspecialAplicable,
  },
  pag2: {
    casilla01: formData?.casilla01,
    casilla02: formData?.casilla02,
    casilla03: formData?.casilla03,
    casilla04: formData?.casilla04,
    casilla05: formData?.casilla05,
    casilla06: formData?.casilla06,
    casilla08: formData?.casilla08,
    casilla10: formData?.casilla10,
    casilla11: formData?.casilla11,
    casilla12: formData?.casilla12,
    casilla13: formData?.casilla13,
    casilla14: formData?.casilla14,
    casilla21: formData?.casilla21,
    casilla22: formData?.casilla22,
    casilla23: formData?.casilla23,
    casilla24: formData?.casilla24,
    casilla25: formData?.casilla25,
    casilla26: formData?.casilla26,
    casilla27: formData?.casilla27,
    casilla28: formData?.casilla28,
    casilla30: formData?.casilla30,
    casilla31: formData?.casilla31,
    casilla32: formData?.casilla32,
    casilla33: formData?.casilla33,
    casilla34: formData?.casilla34,
    casilla500: formData?.casilla500,
    casilla501: formData?.casilla501,
    casilla502: formData?.casilla502,
    casilla503: formData?.casilla503,
    casilla504: formData?.casilla504,
    casilla505: formData?.casilla505,
    casilla545: formData?.casilla545,
    casilla546: formData?.casilla546,
    casilla547: formData?.casilla547,
    casilla548: formData?.casilla548,
    casilla551: formData?.casilla551,
    casilla552: formData?.casilla552,
    casilla643: formData?.casilla643,
    casilla644: formData?.casilla644,
    casilla645: formData?.casilla645,
    casilla646: formData?.casilla646,
    casilla647: formData?.casilla647,
    casilla648: formData?.casilla648,
    casilla649: formData?.casilla649,
    casilla650: formData?.casilla650,
    casilla667: formData?.casilla667,
    casilla668: formData?.casilla668,
    casilla669: formData?.casilla669,
    casilla670: formData?.casilla670,
    casilla671: formData?.casilla671,
    casilla672: formData?.casilla672,
    casilla673: formData?.casilla673,
    casilla674: formData?.casilla674,
    casilla675: formData?.casilla675,
    casilla676: formData?.casilla676,
    casilla677: formData?.casilla677,
    casilla678: formData?.casilla678,
    casilla679: formData?.casilla679,
    casilla680: formData?.casilla680,
    casilla681: formData?.casilla681,
    casilla682: formData?.casilla682,
    casilla683: formData?.casilla683,
    casilla684: formData?.casilla684,
    casilla685: formData?.casilla685,
    casilla686: formData?.casilla686,
    casilla687: formData?.casilla687,
    casilla688: formData?.casilla688,
    casilla689: formData?.casilla689,
    casilla690: formData?.casilla690,
    casilla700: formData?.casilla700,
    casilla701: formData?.casilla701,
    casilla702: formData?.casilla702,
    casilla703: formData?.casilla703,
    casilla704: formData?.casilla704,
    casilla705: formData?.casilla705,
    casilla706: formData?.casilla706,
    casilla707: formData?.casilla707,
    casilla708: formData?.casilla708,
    casilla709: formData?.casilla709,
    casilla710: formData?.casilla710,
    casilla711: formData?.casilla711,
    casilla712: formData?.casilla712,
    casilla713: formData?.casilla713,
    casilla714: formData?.casilla714,
    casilla715: formData?.casilla715,
    casilla716: formData?.casilla716,
    casilla717: formData?.casilla717,
    casilla718: formData?.casilla718,
    casilla719: formData?.casilla719,
    casilla720: formData?.casilla720,
    casilla721: formData?.casilla721,
    casilla722: formData?.casilla722,
    casilla723: formData?.casilla723,
  },
  pag2Bis: {
    casilla35: formData?.casilla35,
    casilla36: formData?.casilla36,
    casilla41: formData?.casilla41,
    casilla42: formData?.casilla42,
    casilla43: formData?.casilla43,
    casilla44: formData?.casilla44,
    casilla45: formData?.casilla45,
    casilla46: formData?.casilla46,
    casilla47: formData?.casilla47,
    casilla599: formData?.casilla599,
    casilla600: formData?.casilla600,
    casilla601: formData?.casilla601,
    casilla602: formData?.casilla602,
    casilla663: formData?.casilla663,
    casilla664: formData?.casilla664,
    casilla665: formData?.casilla665,
    casilla666: formData?.casilla666,
    casilla691: formData?.casilla691,
    casilla692: formData?.casilla692,
    casilla693: formData?.casilla693,
    casilla694: formData?.casilla694,
  },
  pag3: {
    casilla190: formData?.casilla190,
    casilla191: formData?.casilla191,
    casilla196: formData?.casilla196,
    casilla197: formData?.casilla197,
    casilla202: formData?.casilla202,
    casilla203: formData?.casilla203,
    casilla208: formData?.casilla208,
    casilla209: formData?.casilla209,
    casilla214: formData?.casilla214,
    casilla215: formData?.casilla215,
    casilla48: formData?.casilla48,
    casilla49: formData?.casilla49,
    casilla50: formData?.casilla50,
    casilla506: formData?.casilla506,
    casilla507: formData?.casilla507,
    casilla51: formData?.casilla51,
    casilla512: formData?.casilla512,
    casilla513: formData?.casilla513,
    casilla514: formData?.casilla514,
    casilla515: formData?.casilla515,
    casilla52: formData?.casilla52,
    casilla520: formData?.casilla520,
    casilla521: formData?.casilla521,
    casilla53: formData?.casilla53,
    casilla54: formData?.casilla54,
    casilla55: formData?.casilla55,
    casilla56: formData?.casilla56,
    casilla57: formData?.casilla57,
    casilla603: formData?.casilla603,
    casilla604: formData?.casilla604,
    casilla605: formData?.casilla605,
    casilla606: formData?.casilla606,
    casilla607: formData?.casilla607,
    casilla608: formData?.casilla608,
    casilla609: formData?.casilla609,
    casilla610: formData?.casilla610,
    casilla611: formData?.casilla611,
    casilla612: formData?.casilla612,
    casilla613: formData?.casilla613,
    casilla614: formData?.casilla614,
    casilla615: formData?.casilla615,
    casilla616: formData?.casilla616,
    casilla617: formData?.casilla617,
    casilla618: formData?.casilla618,
    casilla619: formData?.casilla619,
    casilla620: formData?.casilla620,
    casilla621: formData?.casilla621,
    casilla622: formData?.casilla622,
    casilla623: formData?.casilla623,
    casilla624: formData?.casilla624,
    casilla625: formData?.casilla625,
    casilla626: formData?.casilla626,
    casilla627: formData?.casilla627,
    casilla628: formData?.casilla628,
    casilla629: formData?.casilla629,
    casilla630: formData?.casilla630,
    casilla695: formData?.casilla695,
    casilla696: formData?.casilla696,
    casilla697: formData?.casilla697,
    casilla698: formData?.casilla698,
    casilla724: formData?.casilla724,
    casilla725: formData?.casilla725,
    casilla726: formData?.casilla726,
    casilla727: formData?.casilla727,
    casilla728: formData?.casilla728,
    casilla729: formData?.casilla729,
    casilla730: formData?.casilla730,
    casilla731: formData?.casilla731,
    casilla732: formData?.casilla732,
    casilla733: formData?.casilla733,
    casilla734: formData?.casilla734,
    casilla735: formData?.casilla735,
    casilla736: formData?.casilla736,
    casilla737: formData?.casilla737,
    casilla745: formData?.casilla745,
    casilla746: formData?.casilla746,
    casilla747: formData?.casilla747,
    casilla748: formData?.casilla748,
    casilla749: formData?.casilla749,
    casilla750: formData?.casilla750,
    casilla751: formData?.casilla751,
    casilla752: formData?.casilla752,
    casilla753: formData?.casilla753,
    casilla754: formData?.casilla754,
    casilla755: formData?.casilla755,
    casilla756: formData?.casilla756,
    casilla757: formData?.casilla757,
    casilla758: formData?.casilla758,
    casilla759: formData?.casilla759,
    casilla760: formData?.casilla760,
    casilla761: formData?.casilla761,
    casilla762: formData?.casilla762,
    casilla763: formData?.casilla763,
    casilla764: formData?.casilla764,
    casilla765: formData?.casilla765,
    casilla766: formData?.casilla766,
    casilla767: formData?.casilla767,
    casilla768: formData?.casilla768,
  },
  pag4: {
    casilla220: formData?.casilla220,
    casilla221: formData?.casilla221,
    casilla522: formData?.casilla522,
    casilla58: formData?.casilla58,
    casilla587: formData?.casilla587,
    casilla588: formData?.casilla588,
    casilla59: formData?.casilla59,
    casilla597: formData?.casilla597,
    casilla598: formData?.casilla598,
    casilla60: formData?.casilla60,
    casilla61: formData?.casilla61,
    casilla62: formData?.casilla62,
    casilla63: formData?.casilla63,
    casilla631: formData?.casilla631,
    casilla632: formData?.casilla632,
    casilla633: formData?.casilla633,
    casilla634: formData?.casilla634,
    casilla635: formData?.casilla635,
    casilla636: formData?.casilla636,
    casilla637: formData?.casilla637,
    casilla638: formData?.casilla638,
    casilla639: formData?.casilla639,
    casilla64: formData?.casilla64,
    casilla65: formData?.casilla65,
    casilla651: formData?.casilla651,
    casilla652: formData?.casilla652,
    casilla660: formData?.casilla660,
    casilla661: formData?.casilla661,
    casilla738: formData?.casilla738,
    casilla739: formData?.casilla739,
    casilla740: formData?.casilla740,
    casilla741: formData?.casilla741,
    casilla769: formData?.casilla769,
    casilla770: formData?.casilla770,
    casilla771: formData?.casilla771,
    casilla772: formData?.casilla772,
    casilla773: formData?.casilla773,
    casilla774: formData?.casilla774,
    casilla775: formData?.casilla775,
    casilla776: formData?.casilla776,
  },
  pag6: {
    casilla100: formData?.casilla100,
    casilla101: formData?.casilla101,
    casilla102: formData?.casilla102,
    casilla103: formData?.casilla103,
    casilla104: formData?.casilla104,
    casilla105: formData?.casilla105,
    casilla106: formData?.casilla106,
    casilla107: formData?.casilla107,
    casilla108: formData?.casilla108,
    casilla110: formData?.casilla110,
    casilla125: formData?.casilla125,
    casilla126: formData?.casilla126,
    casilla127: formData?.casilla127,
    casilla128: formData?.casilla128,
    casilla227: formData?.casilla227,
    casilla228: formData?.casilla228,
    casilla524: formData?.casilla524,
    casilla525: formData?.casilla525,
    casilla526: formData?.casilla526,
    casilla653: formData?.casilla653,
    casilla662: formData?.casilla662,
    casilla85: formData?.casilla85,
    casilla86: formData?.casilla86,
    casilla87: formData?.casilla87,
    casilla88: formData?.casilla88,
    casilla89: formData?.casilla89,
    casilla90: formData?.casilla90,
    casilla91: formData?.casilla91,
    casilla92: formData?.casilla92,
    casilla93: formData?.casilla93,
    casilla94: formData?.casilla94,
    casilla95: formData?.casilla95,
    casilla96: formData?.casilla96,
    casilla97: formData?.casilla97,
    casilla98: formData?.casilla98,
    casilla99: formData?.casilla99,
    resultLiqAnCasilla658: formData?.resultLiqAnCasilla658,
    resultLiqAnCasilla659: formData?.resultLiqAnCasilla659,
    resultLiqAnCasilla84: formData?.resultLiqAnCasilla84,
    tribRazTerrCasilla658: formData?.tribRazTerrCasilla658,
    tribRazTerrCasilla659: formData?.tribRazTerrCasilla659,
    tribRazTerrCasilla84: formData?.tribRazTerrCasilla84,
  },
  pag7: {
    casilla109: formData?.casilla109,
    casilla111: formData?.casilla111,
    casilla113: formData?.casilla113,
    casilla230: formData?.casilla230,
    casilla231: formData?.casilla231,
    casilla232: formData?.casilla232,
    casilla523: formData?.casilla523,
    casilla654: formData?.casilla654,
    casilla655: formData?.casilla655,
    casilla656: formData?.casilla656,
    casilla657: formData?.casilla657,
    prorrata1ActividadDesarrollada: formData?.prorrata1ActividadDesarrollada,
    prorrata1Casilla114: formData?.prorrata1Casilla114,
    prorrata1Casilla115: formData?.prorrata1Casilla115,
    prorrata1Casilla116: formData?.prorrata1Casilla116,
    prorrata1Casilla117: formData?.prorrata1Casilla117,
    prorrata1Casilla118: formData?.prorrata1Casilla118,
    prorrata2ActividadDesarrollada: formData?.prorrata2ActividadDesarrollada,
    prorrata2Casilla114: formData?.prorrata2Casilla114,
    prorrata2Casilla115: formData?.prorrata2Casilla115,
    prorrata2Casilla116: formData?.prorrata2Casilla116,
    prorrata2Casilla117: formData?.prorrata2Casilla117,
    prorrata2Casilla118: formData?.prorrata2Casilla118,
    prorrata3ActividadDesarrollada: formData?.prorrata3ActividadDesarrollada,
    prorrata3Casilla114: formData?.prorrata3Casilla114,
    prorrata3Casilla115: formData?.prorrata3Casilla115,
    prorrata3Casilla116: formData?.prorrata3Casilla116,
    prorrata3Casilla117: formData?.prorrata3Casilla117,
    prorrata3Casilla118: formData?.prorrata3Casilla118,
    prorrata4ActividadDesarrollada: formData?.prorrata4ActividadDesarrollada,
    prorrata4Casilla114: formData?.prorrata4Casilla114,
    prorrata4Casilla115: formData?.prorrata4Casilla115,
    prorrata4Casilla116: formData?.prorrata4Casilla116,
    prorrata4Casilla117: formData?.prorrata4Casilla117,
    prorrata4Casilla118: formData?.prorrata4Casilla118,
    prorrata5ActividadDesarrollada: formData?.prorrata5ActividadDesarrollada,
    prorrata5Casilla114: formData?.prorrata5Casilla114,
    prorrata5Casilla115: formData?.prorrata5Casilla115,
    prorrata5Casilla116: formData?.prorrata5Casilla116,
    prorrata5Casilla117: formData?.prorrata5Casilla117,
    prorrata5Casilla118: formData?.prorrata5Casilla118,
  },
  pag8: {
    casilla139: formData?.casilla139,
    casilla140: formData?.casilla140,
    casilla141: formData?.casilla141,
    casilla142: formData?.casilla142,
    casilla143: formData?.casilla143,
    casilla144: formData?.casilla144,
    casilla145: formData?.casilla145,
    casilla146: formData?.casilla146,
    casilla147: formData?.casilla147,
    casilla148: formData?.casilla148,
    casilla149: formData?.casilla149,
    casilla150: formData?.casilla150,
    casilla151: formData?.casilla151,
    casilla152: formData?.casilla152,
    casilla153: formData?.casilla153,
    casilla154: formData?.casilla154,
    casilla155: formData?.casilla155,
    casilla156: formData?.casilla156,
    casilla157: formData?.casilla157,
    casilla158: formData?.casilla158,
    casilla159: formData?.casilla159,
    casilla160: formData?.casilla160,
    casilla161: formData?.casilla161,
    casilla162: formData?.casilla162,
    casilla163: formData?.casilla163,
    casilla164: formData?.casilla164,
    casilla165: formData?.casilla165,
    casilla166: formData?.casilla166,
    casilla167: formData?.casilla167,
    casilla168: formData?.casilla168,
    casilla169: formData?.casilla169,
    casilla170: formData?.casilla170,
    casilla171: formData?.casilla171,
    casilla172: formData?.casilla172,
    casilla173: formData?.casilla173,
    casilla174: formData?.casilla174,
    casilla175: formData?.casilla175,
    casilla176: formData?.casilla176,
    casilla177: formData?.casilla177,
    casilla178: formData?.casilla178,
    casilla179: formData?.casilla179,
    casilla180: formData?.casilla180,
    casilla181: formData?.casilla181,
    casilla182: formData?.casilla182,
    casilla183: formData?.casilla183,
    casilla184: formData?.casilla184,
    casilla185: formData?.casilla185,
    casilla186: formData?.casilla186,
    casilla187: formData?.casilla187,
    casilla188: formData?.casilla188,
    casilla189: formData?.casilla189,
    casilla640: formData?.casilla640,
    casilla641: formData?.casilla641,
    casilla642: formData?.casilla642,
  },
})
